import {  useEffect, useState } from "react"
import axios from 'axios'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FilterMatchMode, FilterService } from 'primereact/api';
import { Dropdown  } from 'primereact/dropdown'
import { comparer } from "../../utils/comparer";
import { useToast } from "../../toastHook"
import { useAuthUser } from "../../auth"
import { displayConsultantExperience, displayConsultatLastActiviteSince } from '../../utils/experienceUtility'

export const CalculatedCvComponent = () => {

    const [listCv, setListCv] = useState([]);
    const [availableActivites, setAvalaibleActivites] = useState([]);

    const { display } = useToast();
    const { checkRole } = useAuthUser();

    useEffect(() => {
        axios.get('/api/calculatedcv/getlast')
            .then(response => {

                response.data.sort((x, y) => comparer(x.nom, y.nom))

                setListCv(response.data);

                let activites = ['Aucune'];

                response.data.forEach(x => {
                    if (x.activites) {
                        x.activites.forEach(y => {
                            if (!activites.find(z => y.name === z)) {
                                activites = [...activites, y.name]
                            }
                        })
                    }
                });

                activites.sort();

                setAvalaibleActivites(activites);
            });

    }, [])

    const [doOnce, setDoOnce] = useState(false);
    const launchCalculAction = () => {

        if (doOnce) {
            return;
        }

        setDoOnce(true);

        axios.get("/api/calculatecvjob/calculate")
            .then(
                response => {
                    display({
                        titre: 'le calcul a démarré',
                        text: `le  calcul a démarré, veuillez rafraîchir la page dans 10 min`,
                        severity: 'success'
                    });
                }
        )
    }


    const filterActivityFunction = (value, filter) => {       


        if (!filter) {
            return true;
        }

        if (!value || value.length === 0) {
            return filter === 'Aucune'
        }
        else {
            return value.filter(x => x.name === filter).length > 0
        }
    }

    useEffect(() => {
        FilterService.register("CalculatedCvComponent_activite", filterActivityFunction)
    }, [])

    const [filters, setFilters] = useState({
        prenom : { value: null, matchMode: FilterMatchMode.STARTS_WITH, filtertype: "num" },
        nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH, filtertype: "num" },
        isSalarie: { value: null, matchMode: FilterMatchMode.EQUAL },
        activites: {
            value: null, matchMode: 'CalculatedCvComponent_activite'}
    });

    const getActivite = x => {
        if (x.competence) {
            return x.competence.activite + " / " + x.competence.competence;
        }

        return x.name
    }

    const displayActivite = x =>  <span key={x.personalInfoId + "##" + getActivite(x)} className="col-4 alert alert-secondary">{ getActivite(x) } : {displayConsultantExperience(x.experience)} <br /> Dernière expérience: {displayConsultatLastActiviteSince(x.lastSince)  }</span>


    const activityFilterTemplate = (options) => {

        return <Dropdown value={options.value} options={availableActivites} onChange={(e) => {
            setFilters({
                ...filters, activites: {
                    value: e.value, matchMode: 'CalculatedCvComponent_activite'
                }
            });
             options.filterCallback(e.value, options.index);
        }} placeholder="Select One" className="p-column-filter" showClear />
    }

    const isSalarieFilter = options => <Dropdown value={options.value} options={
        [{ label: 'Tous', value: null }, { label: 'Oui', value: true }, { label: 'Non', value: false }]} onChange={e => setFilters({ ...filters, isSalarie: { value: e.value, matchMode: FilterMatchMode.EQUALS } })}  showClear ></Dropdown>

    const formatActivite = row => {


        if (!row.activites) {
            return <></>
        }
        else {
            return <div  className="d-flex flex-row flex-wrap gap-4">
                {row.activites.map(displayActivite)}
                { row.competences ?  row.competences.map(displayActivite) : <></> }
            </div>
        }
    }

    const formatTotalExperience = row => displayConsultantExperience(row.totalExperience); 

    const openCv = value => {

        const { personalInfoId, prenom, nom } = value;

        axios.get("/api/dcgenpageuser/getcv?personalinfoid=" + personalInfoId).then(response => {

            if (!response.data) {
                display({
                    titre: 'pas de cv',
                    text: `pas de cv pour ${prenom} ${nom}`,
                    severity: 'info'
                });
            }
            else {
                window.open(response.data, "_blank");
            }
            });
    }

    const formatOpenCv = row => {
        return <i onClick={() => openCv({  personalInfoId:  row.personalInfoId , prenom: row.prenom , nom : row.nom }) } className="pi pi-info-circle text-primary" />
    }

    const formatIsSalarie = row => row.isSalarie ? "oui" : "non";

    let launchCalcul = <></>;
    if (checkRole("Pocahontas_CalculateCv")) {
        launchCalcul = <><br /> <button onClick={launchCalculAction } className="btn btn-outline-primary">cliquez ici pour lancer un calcul</button></>
    }

    return <div>
        <div className="alert alert-info">Vous trouverez ici les derniers résultats des calculs de cv.
            Chaque consultant est associé à des activités avec expérience et niveau lorsque cela est connu.
            { launchCalcul }
        </div>
        <div>
            <DataTable value={listCv} tableStyle={{ width: '100%' }} className="calculatedCv-table"
                filters={filters} filterDisplay="row"  >
                <Column field="prenom" header="Prénom" filter  />
                <Column field="nom" header="Nom" filter sortable />
                <Column body={ formatIsSalarie } field="isSalarie" header="Salarié?" filter filterElement={ isSalarieFilter } />
                <Column field="totalExperience" header="Expérience totale (année)"  sortable body={ formatTotalExperience } />
                <Column  header="Activités" field="activites" filter body={formatActivite} filterElement={activityFilterTemplate} />
                <Column  body={ formatOpenCv } />
            </DataTable>
        </div>
    </div >
}













